import { NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { firstValueFrom } from 'rxjs';
import { ObservableCachedDataLoaderService } from 'utils';

@Component({
  selector: 'lib-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, DynamicHooksModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgComponent implements OnChanges {
  private http = inject(HttpClient);
  private cdr = inject(ChangeDetectorRef);
  private dataLoader = inject(ObservableCachedDataLoaderService);
  @Input() svg: string;
  svgHtml: string;

  async ngOnChanges() {
    const svg = this.svg as keyof SafeHtml;
    const svgFullPath = `/resources/${svg}.svg`;

    this.svgHtml = await firstValueFrom(this.getIcon(svgFullPath));

    this.cdr.markForCheck();
  }

  getIcon(icon: string) {
    return this.dataLoader.get('icon_' + icon, () => this.http.get(icon, { responseType: 'text' }));
  }
}
